import Modal from './Modal';
export default Modal;



// WEBPACK FOOTER //
// ../core/src/components/Modal/index.js